(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidLabCompendiumDeleteController',CovidLabCompendiumDeleteController);

    CovidLabCompendiumDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidLabCompendium'];

    function CovidLabCompendiumDeleteController($uibModalInstance, entity, CovidLabCompendium) {
        var vm = this;

        vm.covidLabCompendium = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidLabCompendium.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
